/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/monument_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0zM20 26h6v1h-6zM6 26h6v1H6zM20 24h5v1h-5zM7 24h5v1H7zM20 22h4v1h-4zM8 22h4v1H8zM16 5a8 8 0 00-8 8v8h4v-8a4 4 0 018 0v8h4v-8a8 8 0 00-8-8z"/><circle pid="1" cx="16" cy="13" r="2"/>'
  }
})
